import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import "@maersk-global/mds-components-core/mc-loading-indicator";

import { VoyageImoModel } from '../../../src/models/voyage-imo-model'
import { VoyageImoEventNames } from '../../../src/models/voyage-imo-model-impl'


@customElement('voy-loader')
export class VoyLoader extends LitElement {

    @property({ type: Boolean }) showLoader = false;
    @property({type: String, attribute:'label'}) label: string = "";

    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
            :host {
                font-family: MaerskText;
                position:relative;
                z-index: 10;
            }
            .spinner {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: white;
                flex-direction: column;
            } 
            `   
        ];
    }

    connectedCallback() {
        super.connectedCallback()
        VoyageImoModel?.addEventListener('show-loader', this.show);
        VoyageImoModel?.addEventListener('hide-loader', this.hide);
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        VoyageImoModel?.removeEventListener('show-loader', this.show);
        VoyageImoModel?.removeEventListener('hide-loader', this.hide);
    }

    private show = () => this.showLoader = true;
    private hide = () => this.showLoader = false;

    render() {

        return this.showLoader
            ? html`<div class="spinner">
                <mc-loading-indicator fit="large" ></mc-loading-indicator>
                <h4>${this.label}</h4>
                </div>`
            : html``
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'voy-loader': VoyLoader
    }
}
